import { Avatar, Box, Button, HStack, Img, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react"
import qs from 'query-string'
import { useContext } from 'react'
import { FiChevronDown } from "react-icons/fi"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { isEmpty } from "underscore"
import { UserContext, UserContextProps } from "../providers/UserProvider"

const NavStyle = {
    color: 'blackAlpha.700',
    ml: '1rem',
    mr: '1rem',
    borderColor: 'white',
    borderBottomWidth: '4px',
    borderRadius: 0,
    fontSize: '20px',
    fontWeight: 'regular',
}

const ActiveNavStyle = {
    ...NavStyle,
    borderBottomWidth: '4px',
    borderColor: '#333',
    color: '#333'
}
const Header = () => {
    const { user, setCategory } = useContext(UserContext) as UserContextProps
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const getNavStyle = (route: string) => {
        if (route === location.pathname) {
            return { ...ActiveNavStyle }
        } else {
            return { ...NavStyle }
        }
    }

    const changePage = (route: string, updated_params?: any) => {
        const sap_id = searchParams.get(`sap_id`)
        const token = searchParams.get(`token`)
        const category = searchParams.get(`category`)
        let params: any = {}
        if(token){
            params.token = token
        }
        if(sap_id){
            params.sap_id = sap_id
        }
        if(category){
            params.category = category
        }

        if(!isEmpty(updated_params)){
            params = {
                ...params,
                ...updated_params
            }
        }

        if(params.unset){
            for(let item of params.unset){
                delete params[item]
            }
            delete params.unset
        }

        console.log(params, 'params')

        if(!isEmpty(params)){
            route += `?${qs.stringify(params)}`
        }
        navigate(route)
        if(!isEmpty(updated_params) && updated_params.category){
            setCategory(updated_params.category)
        }
    }

    const getActiveCategory = ()=> {
        let category = searchParams.get(`category`)
        if(!category){
            category =  'LCBO'
        }
        return category
    }

    return (
        <HStack position={'fixed'} zIndex={1} bgColor={'white'} boxShadow={'md'} borderBottomWidth={'1px'} p={'16px 50px'} w={'full'} justify={'space-between'}>
            <HStack spacing={'60px'}>
                <Img w={'240px'} src={'/assets/images/logo.jpg'} />
                <Menu>
                    <MenuButton colorScheme={'blue'} as={Button} rightIcon={<FiChevronDown />}>
                        { getActiveCategory() }
                    </MenuButton>
                    <MenuList>
                        <MenuItem onClick={()=> changePage(location.pathname, {category: 'LCBO', unset: ['sap_id']})}>LCBO</MenuItem>
                        <MenuItem onClick={()=> changePage(location.pathname, {category: 'LCO', unset: ['sap_id']})}>LCO</MenuItem>
                        <MenuItem onClick={()=> changePage(location.pathname, {category: 'GROCERY', unset: ['sap_id']})}>GROCERY</MenuItem>
                    </MenuList>
                </Menu>
            </HStack>
            <HStack spacing={'16px'}>
                <Button onClick={() => changePage('/get-in')} variant={'unstyled'} {...getNavStyle('/get-in')}>GET IN</Button>
                <Button onClick={() => changePage('/looks-good')} variant={'unstyled'} {...getNavStyle('/looks-good')}>LOOK GOOD / GET HEAVY</Button>
                <Button onClick={() => changePage('/innovation')} variant={'unstyled'} {...getNavStyle('/innovation')}>INNOVATION</Button>
                {user &&
                    <Box pl={'3rem'} pr={'2rem'}>
                        <Avatar name={user.name} />
                    </Box>
                }

            </HStack>
        </HStack>
    )
}

export default Header